export default __webpack_public_path__ + "static/Medellin-activate-e18fa4094b23687df5f05b0d31d54cfc.svg";